module.exports = __webpack_public_path__ + "static/media/Icon awesome-building.edf039f5.svg";